import { call, put } from 'redux-saga/effects';
import Http from '../../../libs/Http';

export function* fetchTracking(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.get, '/tracking/list', {
    query: {}
  });
  yield put({
    // $global: true,
    type: 'SET_TRACKING',
    payload: data
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export default function* ({ takeFirst, takeLatest, takeEvery }) {
  yield [
    takeFirst('FETCH_TRACKING', fetchTracking),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Tracking/Tracking.sagas.js